import { SvgIcon } from '@material-ui/core';

const DownloadIcon = (props) => {
	return (
		<SvgIcon
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_1389_222781)">
				<path d="M7 10L12 15L17 10H7Z" fill="#BDBDBD" />
			</g>
			<defs>
				<clipPath id="clip0_1389_222781">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
};

export default DownloadIcon;
